var _style, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAuth(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "auth_svg__Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 653 345",
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".auth_svg__st1{opacity:.15;fill:#32caf8;enable-background:new}.auth_svg__st2{fill:#2bc3f7}.auth_svg__st3{fill:#9fe791}.auth_svg__st4{opacity:.1;fill:#2898b2;enable-background:new}.auth_svg__st5{fill:#fff}.auth_svg__st6{fill:#426572}.auth_svg__st7{fill:#a9ea9c}.auth_svg__st10{opacity:.15}.auth_svg__st11{fill:#32caf8}")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "auth_svg__Layer_2_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "auth_svg__Layer_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M74.5,96h350c41.1,0,74.5,33.3,74.5,74.5c0,0,0,0,0,0l0,0c0,41.1-33.3,74.5-74.5,74.5c0,0,0,0,0,0h-350 C33.4,245,0,211.7,0,170.5c0,0,0,0,0,0l0,0C0,129.4,33.3,96,74.5,96C74.5,96,74.5,96,74.5,96z",
    opacity: 0.15,
    fill: "#a9ea9c"
  }), /*#__PURE__*/React.createElement("path", {
    className: "auth_svg__st1",
    d: "M220.5,60h358c41.1,0,74.5,33.3,74.5,74.5c0,0,0,0,0,0l0,0c0,41.1-33.3,74.5-74.5,74.5c0,0,0,0,0,0h-358 c-41.1,0-74.5-33.3-74.5-74.5c0,0,0,0,0,0l0,0C146,93.4,179.3,60,220.5,60C220.5,60,220.5,60,220.5,60z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "auth_svg__st2",
    cx: 86.5,
    cy: 236.5,
    r: 7.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "auth_svg__st2",
    cx: 575.5,
    cy: 117.5,
    r: 7.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "auth_svg__st3",
    cx: 160.5,
    cy: 337.5,
    r: 7.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "auth_svg__st3",
    cx: 475.5,
    cy: 23.5,
    r: 7.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "auth_svg__st4",
    d: "M113,66h401c6.6,0,12,5.4,12,12v240c0,6.6-5.4,12-12,12H113c-6.6,0-12-5.4-12-12V78C101,71.4,106.4,66,113,66 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "auth_svg__st5",
    d: "M128,49h401c6.6,0,12,5.4,12,12v240c0,6.6-5.4,12-12,12H128c-6.6,0-12-5.4-12-12V61C116,54.4,121.4,49,128,49 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "auth_svg__st6",
    d: "M531.5,317.5h-77.4v-10h77.4c3.9,0,7-3.1,7-7v-240c0-3.9-3.1-7-7-7h-401c-3.9,0-7,3.1-7,7v240 c0,3.9,3.1,7,7,7H406v10H130.5c-9.4,0-17-7.6-17-17v-240c0-9.4,7.6-17,17-17l0,0h401c9.4,0,17,7.6,17,17l0,0l0,0v240 C548.5,309.9,540.9,317.5,531.5,317.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "auth_svg__st7",
    d: "M218,86h62c6.6,0,12,5.4,12,12v40c0,6.6-5.4,12-12,12h-62c-6.6,0-12-5.4-12-12V98C206,91.4,211.4,86,218,86z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "auth_svg__st1",
    d: "M173.1 220H507.1V284H173.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "auth_svg__st2",
    d: "M177,179.5h134.8c5.8,0,5.8-9,0-9H177C171.2,170.5,171.2,179.5,177,179.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "auth_svg__st3",
    d: "M177,203.1h116.5c5.8,0,5.8-9,0-9H177C171.2,194.1,171.2,203.1,177,203.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "auth_svg__st4",
    d: "M535,46H197.2L130,31.8L60,46.6v63.2c0,44.5,70,74.2,70,74.2s70-29.7,70-74.2V73h335c6.6,0,12,5.4,12,12V58 C547,51.4,541.6,46,535,46z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "auth_svg__st7",
    d: "M121.8,180.3c0,0,63.7-31.9,63.7-79.7V36.9L121.8,21L58,36.9v63.7C58,148.4,121.8,180.3,121.8,180.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.5,70.3V97c0,47.8-63.7,79.7-63.7,79.7S58.1,144.8,58.1,97V70.3c0,47.8,63.7,79.7,63.7,79.7 S185.5,118.1,185.5,70.3z",
    fill: "#91cd86"
  }), /*#__PURE__*/React.createElement("path", {
    className: "auth_svg__st6",
    d: "M121.8,182.8l-2.7-1.3c-2.7-1.4-67-34.1-67-85V28l69.7-17.4L191.5,28v68.4c0,21.3-11.7,42.9-33.9,62.3 c-10.1,8.8-21.2,16.5-33.1,22.8L121.8,182.8z M64.1,37.4v59c0,38.2,46,66.3,57.7,72.8c11.7-6.6,57.7-34.7,57.7-72.8v-59L121.8,23 L64.1,37.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "auth_svg__st5",
    d: "M122.8,113.9l-4.1-41.6V53h17v19.2l-4,41.6H122.8z M119.4,135v-15.7h15.7V135H119.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "auth_svg__st6",
    d: "M377.9 143.7h-11.6l-4.6-12h-21.1l-4.4 12H325l20.5-52.7h11.3L377.9 143.7zM358.3 122.8l-7.3-19.6-7.1 19.6H358.3zM383.5 90.9h10.6v28.6c-.1 2.9 0 5.9.4 8.8.4 2.1 1.6 3.9 3.3 5.2 2 1.4 4.5 2.1 7 2 3 0 5.3-.6 6.8-1.9 1.5-1.1 2.5-2.7 2.8-4.6.4-3 .5-6 .5-9V90.9h10.7v27.7c0 6.3-.3 10.8-.9 13.4-.5 2.4-1.6 4.7-3.2 6.6-1.7 1.9-3.8 3.4-6.2 4.3-3.2 1.2-6.7 1.7-10.1 1.6-5 0-8.9-.6-11.5-1.7-2.4-1-4.5-2.6-6.2-4.5-1.4-1.7-2.5-3.7-3-5.8-.8-4.4-1.1-8.9-1-13.4L383.5 90.9zM448.6 143.7V99.8h-15.6v-8.9h41.9v8.9h-15.6v43.8H448.6zM481.7 143.7V90.9h10.6v20.7h20.9V90.9h10.6v52.7h-10.6v-23h-20.9v23H481.7z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "auth_svg__st10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "auth_svg__st11",
    d: "M588.3,275.8l-14.2,11.8c-3,2.5,1.3,6.7,4.2,4.2l14.3-11.8C595.6,277.5,591.3,273.3,588.3,275.8 L588.3,275.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "auth_svg__st11",
    d: "M591.4,288.8l-11.8-14.2c-2.5-3-6.7,1.3-4.2,4.2l11.8,14.2C589.6,296,593.8,291.7,591.4,288.8z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "auth_svg__st10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "auth_svg__st11",
    d: "M234.9,2.2L220.6,14c-3,2.5,1.3,6.7,4.2,4.2l14.2-11.8C242.1,4,237.8-0.2,234.9,2.2L234.9,2.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "auth_svg__st11",
    d: "M237.9,15.3L226.1,1c-2.5-3-6.7,1.3-4.2,4.2l11.8,14.2C236.1,22.5,240.3,18.2,237.9,15.3L237.9,15.3z"
  }))))));
}

export default SvgAuth;